// Request options for fetching an artifact's bytes. Only AgentHub's own
// origins get the user's bearer token (dev) and cookies (prod, see
// shared/auth/tokenStorage.ts); an external artifact host must never
// receive them.

import { getToken } from '@/shared/auth';
import { readEnv } from '@/shared/config';

function isAgentHubUrl(url: string): boolean {
  const pageOrigin = globalThis.location?.origin;
  try {
    const origin = new URL(url, pageOrigin).origin;
    return origin === pageOrigin || origin === new URL(readEnv('VITE_API_BASE_URL') || '/', pageOrigin).origin;
  } catch {
    return false;
  }
}

export function artifactFetchInit(url: string): RequestInit {
  if (!isAgentHubUrl(url)) return { credentials: 'omit' };
  const token = getToken();
  return { credentials: 'include', headers: token ? { Authorization: `Bearer ${token}` } : undefined };
}
